var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.mode === "coupon"
    ? _c("div", { staticClass: "adTile coupon" }, [_vm._t("coupon")], 2)
    : _vm.mode === "html"
    ? _c(
        "div",
        { staticClass: "adTile plainHtml", class: _vm.config.cssClass },
        [
          _c("div", { domProps: { innerHTML: _vm._s(_vm.plainHtml) } }),
          _vm._v(" "),
          _vm.config.adTile.valid == "true"
            ? _c("span", {
                staticClass: "countdown",
                domProps: { innerHTML: _vm._s(_vm.config.longHeadline) },
              })
            : _vm._e(),
        ]
      )
    : _c("div", {
        staticClass: "adTile currentSale",
        class: "d" + _vm.doy,
        style:
          "background-color:var(--actionbar-bk);background-size:cover;background-image: url(" +
          _vm.backgroundimage +
          ");",
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }